import { useContext } from 'react';
import ContactList from '../ContactList';
import PanePaper from '../../Molecules/PanePaper';
import BookitupAddIcon from '../../Atoms/BookitupAddIcon';
import { openSelectCreateContactModal } from '../Contact/SelectCreateContactModal';
import { EventParticipationsContext } from '../../Service/Context/EventParticipationContextV2';

const CustomerPane = () => {
  const { saveParticipant } = useContext(EventParticipationsContext);

  return (
    <PanePaper
      withShadow
      withoutBorder
      title="common.contacts"
      tooltip="help.event.contacts.pane"
      rightSection={<BookitupAddIcon onClick={() => openSelectCreateContactModal(saveParticipant)} />}
    >
      <ContactList />
    </PanePaper>
  );
};

export default CustomerPane;
